module.exports = {
  CALCULATE_EMI_API:
    "https://loancalculator.swanforlife.com/lc/v1/calculateEMI",
  LOAN_RATE_API: "https://loancalculator.swanforlife.com/lc/v1/loanRate/",
};
